module.exports = {"371424001":"邢侗街道","371424002":"恒源街道","371424003":"临盘街道","371424100":"临邑镇","371424102":"临南镇","371424103":"德平镇","371424104":"林子镇","371424105":"兴隆镇","371424106":"孟寺镇","371424107":"翟家镇","371424108":"理合务镇","371424202":"宿安乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371424.json
// module id = 1476
// module chunks = 0